import { render, staticRenderFns } from "./IndemnityModalStepAddTemplate.vue?vue&type=template&id=ab19a80e&scoped=true"
import script from "./IndemnityModalStepAddTemplate.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStepAddTemplate.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStepAddTemplate.vue?vue&type=style&index=0&id=ab19a80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19a80e",
  null
  
)

export default component.exports